import React from "react";
// import { BsCheckCircleFill } from "react-icons/bs";

function Roadmap() {
  return (
    <div className="bg-black px-16 pb-24">
      <h1
        id="roadmap"
        className="xl:text-4xl text-3xl text-center text-primary font-extrabold py-6 sm:w-4/6 w-5/6 mx-auto black-bruno"
      >
        <span className="text-2xl better-brush">2022/2023+</span> | Road Map
      </h1>
      <div className="flex flex-col md:grid grid-cols-9 mx-auto py-2 text-blue-50">
        {/* <!-- left --> */}
        <div className="flex flex-row-reverse md:contents">
          <div className="col-start-1 col-end-5 p-4 border border-primary rounded-xl my-4 ml-auto shadow-md w-11/12">
            {/* <p className="leading-tight text-justify text-sm mb-1 ">
              NOVEMBER 2021
            </p> */}
            <h3 className="font-semibold text-xl mb-4 text-primary black-bruno">
              Phase <span className="text-lg better-brush">1:</span>
            </h3>
            <p className="leading-tight text-justify">
              Rebel Rhinos Website will be Launched Alongside the Announcement
              of Minting Details. Further Relationships with Multiple Charities
              will be Created. We will give the Community a Variety of Charities
              to Choose from that Suit our Vision
            </p>
          </div>
          <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
            <div className="h-full w-6 flex items-center justify-center">
              <div className="h-full w-1 bg-[#9e823c] pointer-events-none"></div>
            </div>
            <div className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-primary shadow flex items-center justify-center">
              {/* <BsCheckCircleFill className="text-secondary text-xl" /> */}
            </div>
          </div>
        </div>
        {/* <!-- right --> */}
        <div className="flex md:contents">
          <div className="col-start-5 col-end-6 mr-10 md:mx-auto relative">
            <div className="h-full w-6 flex items-center justify-center">
              <div className="h-full w-1 bg-[#9e823c] pointer-events-none"></div>
            </div>
            <div className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-primary shadow flex items-center justify-center">
              {/* <BsCheckCircleFill className="text-secondary text-xl" /> */}
            </div>
          </div>
          <div className="col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto shadow-md border border-primary w-11/12">
            {/* <p className="leading-tight text-justify text-sm mb-1 ">
              NOVEMBER 2021
            </p> */}
            <h3 className="font-semibold text-xl mb-4 text-primary black-bruno">
              Phase <span className="text-lg better-brush">2:</span>
            </h3>
            <p className="leading-tight text-justify">
              Rebel Rhinos Mint will be Launched Alongside the Creation of the
              Rebel Rhinos DAO. This will Further Kick Start Phase 2 of the
              Marketing Campaign. Establishing Relations with Other Projects
              Whilst Providing Benefits to the Rebel Rhino DAO will be of High
              Priority.
            </p>
          </div>
        </div>
        {/* <!-- left --> */}
        <div className="flex flex-row-reverse md:contents">
          <div className="col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto shadow-md border border-primary w-11/12">
            {/* <p className="leading-tight text-justify text-sm  mb-1 ">
              NOVEMBER 2021
            </p> */}
            <h3 className="font-semibold text-xl mb-4 text-primary black-bruno">
              Charity Fundraiser
              <span className="text-lg better-brush ">:</span>
            </h3>
            <p className="leading-tight text-justify ">
              Rebel Rhinos are Planning on Releasing Six 1 of 1 Rhinos That will
              be Significantly Different to their predecessors. We Aim to
              Auction the Family of Six Rhinos on Magic Eden with 100% of the
              Proceeds Going Towards the Community Voted Charity.
            </p>
          </div>
          <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
            <div className="h-full w-6 flex items-center justify-center">
              <div className="h-full w-1 bg-[#9e823c] pointer-events-none"></div>
            </div>
            <div className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-primary shadow"></div>
          </div>
        </div>
        {/* <!-- right --> */}
        <div className="flex md:contents">
          <div className="col-start-5 col-end-6 mr-10 md:mx-auto relative">
            <div className="h-full w-6 flex items-center justify-center">
              <div className="h-full w-1 bg-[#9e823c] pointer-events-none"></div>
            </div>
            <div className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-primary shadow"></div>
          </div>
          <div className="col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto shadow-md border border-primary w-11/12">
            {/* <p className="leading-tight text-justify text-sm  mb-1 ">
              NOVEMBER 2021
            </p> */}
            <h3 className="font-semibold text-xl mb-4 text-primary black-bruno">
              Phase <span className="text-lg better-brush">3:</span>
            </h3>
            <p className="leading-tight text-justify ">
              Rebel Rhino's Mobile Game Teasers will be Released that will
              Include Exciting Surprises for all Rebel Rhino Holders (Further
              Details to be Announced). Established Features Including Merch
              Drops and NFT Expansion will be Priority. Contributing to Rebel
              Rhinos as a Brand, these Features will also Provide Additional
              Benefit to Our Chosen Charities.
            </p>
          </div>
        </div>
        {/* <!-- left --> */}
        <div className="flex flex-row-reverse md:contents">
          <div className="col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto shadow-md border border-primary w-11/12">
            {/* <p className="leading-tight text-justify text-sm  mb-1 ">
              NOVEMBER 2021
            </p> */}
            <h3 className="font-thin text-xl mb-4 text-primary black-bruno">
              Phase <span className="text-lg better-brush">4:</span>
            </h3>
            <p className="leading-tight text-justify ">
              Rebel Rhinos Mobile Game will be Revealed with Our Early
              Supporters Receiving Additional Benefits In-Game and Out. Holders
              of Rebel Rhino NFT's will Receive 75% of Revenue From Game Revenue
              Alongside a Proportion Going to Our Selected Charities. Future
              Collaborations with Well-Established Projects will be Finalised,
              Benefiting Holders and Selected Charities
            </p>
          </div>
          <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
            <div className="h-full w-6 flex items-center justify-center">
              <div className="h-full w-1 bg-[#9e823c] pointer-events-none"></div>
            </div>
            <div className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-primary shadow"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Roadmap;
